import driverAuthBearer from '@websanova/vue-auth/dist/drivers/auth/bearer.js';
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.js';
import driverRouterVueRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js';

export const config = {
    drivers: {
        auth: driverAuthBearer,
        http: driverHttpAxios,
        router: driverRouterVueRouter,
    },
    options: {
        staySignedIn: false,
        tokenDefaultKey: 'farmacia-areosa-auth',
        stores: ['storage'],
        rolesKey: 'role',
        authRedirect: {name: 'login'},
        forbiddenRedirect: {name: 'error.forbidden'},
        notFoundRedirect: {name: 'error.notfound'},
        registerData: {url: '/auth/register', method: 'POST', redirect: {name: 'login'}},
        loginData: {url: '/auth/login', method: 'POST', redirect: '', fetchUser: true},
        logoutData: {url: '/auth/logout', method: 'POST', redirect: {name: 'home'}, makeRequest: true},
        fetchData: {url: '/auth/user', method: 'GET', enabled: true},
        refreshData: {url: '/auth/refresh', method: 'GET', enabled: true, interval: 10}
    }
}

export default config
